import { createContext } from "react"

import { TreeNode } from "shared/types/TreeNode"
import { WithID } from "shared/types/WithID"
import { DragSource } from "shared/types/drag-and-drop/DragSource"

import { TableDragMeta } from "../types/TableDragMeta"

export interface DragMoveContextType {
  nextIndex?: number
  nextParent?: string | null
  insertBefore?: boolean
}

export interface TableDnDContextType<
  I extends WithID,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends TreeNode<I> = any
> {
  dragSource: DragSource<unknown, TableDragMeta> | null
  prevParent?: string | null
  prevIndex?: number
  prevTreeIndex?: number
  onDragMove?: (state: DragMoveContextType) => void
  canInsertInto?: (target: T | null, source: T) => boolean
  availableDragTypes?: string[]
}

export const defaultTableDnDContext: TableDnDContextType<WithID> = {
  dragSource: null
}

export const defaultDragMoveContext: DragMoveContextType = {}

export const TableDnDContext = createContext<TableDnDContextType<WithID>>(
  defaultTableDnDContext
)
export const DragMoveContext = createContext<DragMoveContextType>(
  defaultDragMoveContext
)
